import React, { useState, useEffect } from 'react';
import {Clock, MapPin, Phone, Mail, Instagram, Menu, X, ChevronRight, Heart, ChevronDown, ChevronUp } from 'lucide-react';
import './App.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [showAllCategories, setShowAllCategories] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrolledY > 50);
      
      const sections = ['home', 'about', 'menu', 'gallery', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const toggleCategory = (index) => {
    setExpandedCategories(prev => 
      prev.includes(index) 
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };

  const menuCategories = [
    { 
      category: 'Kahveler', 
      icon: '☕',
      items: [
        { name: 'Espresso', price: '110₺', image: 'espresso' },
        { name: 'Double Espresso', price: '140₺', image: 'doubleespresso' },
        { name: 'Americano', price: '150₺', image: 'americano' },
        { name: 'Buzlu Americano', price: '170₺', image: 'iceamericano' },
        { name: 'Latte', price: '175₺', desc: '(Ekstra Şurup : 15₺ - Ekstra Shot: 20₺)', image: 'latte' },
        { name: 'Buzlu Latte', price: '180₺', desc: '(Ekstra Şurup : 15₺ - Ekstra Shot: 20₺)', image: 'icelatte' },
        { name: 'Cappuccino', price: '170₺', image: 'latte' },
        { name: 'Flat White', price: '180₺', image: 'latte' },
        { name: 'Mocha', price: '180₺', image: 'mocha' },
        { name: 'Buzlu Mocha', price: '200₺', image: 'icemocha' },
        { name: 'White Mocha', price: '195₺', image: 'mocha' },
        { name: 'Buzlu White Mocha', price: '210₺', image: 'icemocha' },
        { name: 'Filtre Kahve', price: '155₺', image: 'filtercoffee' },
        { name: 'Buzlu Filtre Kahve', price: '170₺', image: 'icefiltercoffee' },
        { name: 'Salted Caramel Latte', price: '205₺', image: 'latte' },
        { name: 'Macchiato', price: '165₺', image: 'latte' },
        { name: 'Lungo', price: '125₺', image: 'lungo' },
        { name: 'Cortado', price: '150₺', image: 'cortado' },
        { name: 'Affogato', price: '180₺', image: 'affogato' },
      ]
    },

    {
      category: 'Türk Kahvesi',
      icon: '🇹🇷',
      items: [
        { name: 'Türk Kahvesi', price: '120₺', image: 'turkishcoffee' },
        { name: 'Duble Türk Kahvesi', price: '140₺', image: 'doubleturkishcoffee' },
        { name: 'Damla Sakızlı', price: '145₺', image: 'turkishcoffee' },
        { name: 'Duble Damla Sakızlı', price: '165₺', image: 'doubleturkishcoffee' },
        { name: 'Dibek Kahvesi', price: '125₺', image: 'turkishcoffee' },
        { name: 'Menengiç Kahvesi', price: '125₺', image: 'turkishcoffee' },
      ]
    },

    {
      category: 'Çaylar',
      icon: '🍵',
      items: [
        { name: 'Çay', price: '50₺', image: 'tea' },
        { name: 'Fincan Çay', price: '65₺', image: 'doubleTea' },
        { 
          name: 'Bitki Çayı', 
          price: '155₺', 
          desc: '(Adaçayı, Papatya, Yeşil, Hibiscus)', 
          image: 'herbaltea' 
        },
        { name: 'Chai Tea Latte', price: '200₺', image: 'chaitea' },
        { name: 'Buzlu Chai Tea Latte', price: '215₺', image: 'iceChaitea' },
      ]
    },

    {
      category: 'Tatlılar',
      icon: '🍰',
      items: [
        { name: 'Olea Special', price: '300₺', image: 'oleaspecial' },
        { name: 'Caramel Pearl', price: '330₺', image: 'caramelpearl' },
        { name: 'Tiramisu', price: '310₺', image: 'tiramisu' },
        { name: 'Malaga', price: '330₺', image: 'malaga' },
        { name: 'Ibiza', price: '330₺', image: 'ibiza' },
        { name: 'Magnolia Cup', price: '330₺', image: 'magnolia' },
        { name: 'Polka', price: '350₺', image: 'polka' },
        { name: 'Olea Waffle', price: '300₺', image: 'oleawaffle' },
        { 
          name: 'Cheesecake', 
          price: '350₺', 
          desc: '(Frambuaz, Limonlu, Lotus)', 
          image: 'cheesecake' 
        },
        { name: 'Paris Ekler', price: '330₺', image: 'pariseclair' },
        { name: 'Show Pasta', price: '385₺', image: 'showpasta' },
        { name: 'Dubai Cup', price: '330₺', image: 'dubaicup' },
        { name: 'Strawberry Dream', price: '330₺', image: 'strawberrydream' },
        { 
          name: 'Brownie', 
          price: '330₺', 
          desc: '(Portakallı, Üç Çikolatalı)', 
          image: 'brownie' 
        },
        { name: 'Pistachio Pop', price: '330₺', image: 'pistachiopop' },
        { name: 'Golden Lotus', price: '330₺', image: 'goldenlotus' },
        { name: 'Brownie Hug', price: '330₺', image: 'browniehug' },
        { name: 'Olea Kiss', price: '330₺', image: 'oleakiss' },
        { name: 'San Sebastian', price: '350₺', image: 'sansebastian' },
        { name: 'Antep San Sebastian', price: '375₺', image: 'antepsansebastian' },
      ]
    },

    {
      category: 'Sıcak İçecekler',
      icon: '🔥',
      items: [
        { name: 'Salep', price: '180₺', image: 'salep' },
        { name: 'Sıcak Çikolata', price: '200₺', image: 'hotchocolate' },
      ]
    },

    {
      category: 'Soğuk İçecekler',
      icon: '🧊',
      items: [
        { 
          name: 'Frozen', 
          price: '180₺', 
          desc: '(Kivi, Mango, Ananas, Yeşil elma, Orman meyveli, Çilek)', 
          image: 'frozen' 
        },
        { 
          name: 'Frappe', 
          price: '200₺', 
          desc: '(Çikolata, Vanilya, Karamel, Sade)', 
          image: 'frappe' 
        },
        { 
          name: 'Milkshake', 
          price: '200₺', 
          desc: '(Çikolata, Karamel, Vanilya, Çilek)', 
          image: 'milkshake' 
        },
        { 
          name: 'Limonata', 
          price: '165₺', 
          desc: '(Sade, Brezilya, Çilek)', 
          image: 'lemonade' 
        },
        { name: 'Berry Hibiscus', price: '180₺', image: 'hibiscus' },
        { name: 'Cool Lime', price: '180₺', image: 'coollime' },
        { name: 'Smoothie', price: '180₺', image: 'smoothie' },
      ]
    },

    {
      category: 'Soft İçecekler',
      icon: '🥤',
      items: [
        { name: 'Su', price: '45₺', image: 'water' },
        { name: 'Soda', price: '70₺', image: 'soda' },
        { name: 'Churchill', price: '125₺', image: 'churchill' },
      ]
    },

    {
      category: 'Bubble Tea',
      icon: '🍹',
      items: [
        { 
          name: 'Dragonia',
          price: '180₺',
          desc: '(yeşil elma, mango, yaban mersini, frambuaz)', 
          image: 'bubbletea' },
        { 
          name: 'Hype and Joy', 
          price: '180₺',
          desc: '(yeşil elma, mango, yaban mersini, frambuaz)', 
          image: 'bubbletea' },
        { 
          name: 'Bluorange',
          price: '180₺',
          desc: '(yeşil elma, mango, yaban mersini, frambuaz)',  
          image: 'bubbletea' },
        { 
          name: 'Air Lime Fizzy', 
          price: '180₺', 
          desc: '(yeşil elma, mango, yaban mersini, frambuaz)', 
          image: 'bubbletea' 
        },
      ]
    },

    {
      category: 'Kruvasan',
      icon: '🥐',
      items: [
        { name: 'Sade', price: '165₺', image: 'croissant' },
        { name: 'Çilekli', price: '330₺', image: 'croissant_strawberry' },
        { name: 'Muzlu', price: '330₺', image: 'croissant_banana' },
        { name: 'Çilekli-Muzlu', price: '330₺', image: 'croissant_mix' },
      ]
    },

    {
      category: 'Sandwich',
      icon: '🥪',
      items: [
        { name: 'Roast Beef Sandwich', price: '325₺', image: 'roastbeef' },
        { name: 'Hindi Füme Sandwich', price: '325₺', image: 'turkey' },
        { name: 'Ezine Peynirli Sandwich', price: '325₺', image: 'cheesesandwich' },
      ]
    }
  ];

  const getImageUrl = (imageName) => {
    try {
      return `${process.env.PUBLIC_URL}/images/menu/${imageName}.jpg`;
    } catch {
      return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23d4c4a8' width='100' height='100'/%3E%3Ctext fill='%239d7c57' font-family='Arial' font-size='40' x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle'%3E☕%3C/text%3E%3C/svg%3E`;
    }
  };

  const displayedCategories = showAllCategories 
    ? menuCategories 
    : menuCategories.slice(0, 4); 

  return (
    <div className="min-h-screen bg-coffee-50 font-sans">
      {/* Navigation  */}
      <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg py-3' : 'bg-coffee-800/90 backdrop-blur-sm py-5'
      }`}>
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          <div className="flex items-center gap-3 group cursor-pointer">
            <span className={`text-2xl font-serif font-bold tracking-tight transition-colors duration-500 ${
              scrolled ? 'text-coffee-900' : 'text-white'
            }`}>
              Olea
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            {['Anasayfa', 'Hakkımızda', 'Menü', 'Galeri', 'İletişim'].map((item, index) => {
              const id = ['home', 'about', 'menu', 'gallery', 'contact'][index];
              return (
                <button
                  key={item}
                  onClick={() => scrollToSection(id)}
                  className={`relative text-sm font-medium tracking-wide transition-colors duration-300 group ${
                    scrolled 
                      ? (activeSection === id ? 'text-rose-600' : 'text-coffee-900 hover:text-rose-600')
                      : (activeSection === id ? 'text-rose-400' : 'text-white hover:text-rose-300')
                  }`}
                >
                  {item}
                  <span className={`absolute -bottom-1 left-0 h-0.5 bg-rose-400 transition-all duration-300 ${
                    activeSection === id ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}></span>
                </button>
              );
            })}
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden transition-colors duration-300 ${
              scrolled ? 'text-coffee-900' : 'text-white'
            }`}
          >
            {isMenuOpen ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>

        <div className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${
          isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="bg-coffee-800/98 backdrop-blur-md px-6 py-6 space-y-4 border-t border-rose-400/30">
            {['Anasayfa', 'Hakkımızda', 'Menü', 'Galeri', 'İletişim'].map((item, index) => {
              const id = ['home', 'about', 'menu', 'gallery', 'contact'][index];
              return (
                <button
                  key={item}
                  onClick={() => scrollToSection(id)}
                  className="block w-full text-left text-coffee-100 hover:text-rose-400 font-medium transition-colors duration-300"
                >
                  {item}
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
       {/* Background with gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-coffee-700 via-coffee-800 to-sage-800">
          <div className="absolute inset-0 opacity-20" style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, rgb(255 255 255) 1px, transparent 0)`,
            backgroundSize: '40px 40px'
          }}></div>
        </div>
        
        {/* Floating elements */}
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute rounded-full animate-float"
              style={{
                width: `${Math.random() * 300 + 100}px`,
                height: `${Math.random() * 300 + 100}px`,
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                background: i % 3 === 0 
                  ? 'rgba(251, 113, 133, 0.1)' 
                  : i % 3 === 1 
                  ? 'rgba(90, 115, 89, 0.15)' 
                  : 'rgba(157, 124, 87, 0.12)',
                filter: 'blur(40px)',
                animationDuration: `${Math.random() * 15 + 10}s`,
                animationDelay: `${Math.random() * 5}s`,
              }}
            ></div>
          ))}
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6 max-w-5xl">
          <div className="mb-8 inline-block">
            <div className="relative">
              <Heart className="w-20 h-20 text-rose-400 mx-auto mb-4 animate-pulse" strokeWidth={1.5} fill="currentColor" />
              <div className="absolute inset-0 bg-rose-400/30 blur-3xl rounded-full"></div>
            </div>
          </div>
          
          <h1 className="text-6xl md:text-8xl font-serif font-bold text-white mb-6 tracking-tight leading-tight animate-fadeInUp">
            Olea
          </h1>
          
          <p className="text-xl md:text-3xl text-coffee-200 mb-4 font-light italic tracking-wide animate-fadeInUp-delay-1">
            Üsküdar
          </p>
          
          <p className="text-lg md:text-xl text-coffee-100 mb-12 font-normal tracking-wide max-w-2xl mx-auto animate-fadeInUp-delay-2">
            Her fincan, bir hikaye • Her an, bir deneyim
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fadeInUp-delay-3">
            <button
              onClick={() => scrollToSection('menu')}
              className="group relative inline-flex items-center gap-3 bg-rose-500 hover:bg-rose-600 text-white px-10 py-5 rounded-full font-semibold text-lg transition-all duration-500 shadow-xl hover:shadow-rose-500/50 hover:scale-105"
            >
              Menümüzü İnceleyin
              <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
            </button>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-coffee-200 rounded-full flex items-start justify-center p-1">
            <div className="w-1.5 h-3 bg-coffee-200 rounded-full animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-24 bg-white relative overflow-hidden">
       <div className="absolute top-0 left-0 w-96 h-96 bg-sage-100 rounded-full filter blur-3xl opacity-40"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-coffee-100 rounded-full filter blur-3xl opacity-40"></div>
        
        <div className="max-w-6xl mx-auto px-6 relative z-10">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <div className="animate-fadeInLeft">
              <span className="text-sage-700 font-semibold tracking-wider text-sm uppercase mb-4 block">
                Hikayemiz
              </span>
              <h2 className="text-5xl font-serif font-bold text-coffee-900 mb-6 leading-tight">
                Sevgiyle Hazırlanan
                <span className="block text-rose-500">Her Detay</span>
              </h2>
              <p className="text-coffee-700 text-lg leading-relaxed mb-6">
                Olea, Üsküdar'ın kalbinde, kahve tutkusunu ve sıcak bir atmosferi bir araya getiren özel bir mekan. 
                Her fincanımız, özenle seçilmiş çekirdeklerden, aşkla hazırlanıyor.
              </p>
              <p className="text-coffee-600 text-lg leading-relaxed mb-8">
                Sadece kahve sunmuyoruz; dostluklar kurduğumuz, anılar biriktirdiğimiz, 
                kendimizi iyi hissettiğimiz bir sığınak yaratıyoruz.
              </p>
            </div>
            
            <div className="relative animate-fadeInRight">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                  <div className="aspect-square bg-gradient-to-br from-coffee-300 via-sage-300 to-coffee-400 flex items-center justify-center">
                    <div className="relative w-full h-full overflow-hidden">
                      <img 
                        src={`${process.env.PUBLIC_URL}/images/gallery/foto8.jpg`}
                        alt="Galeri fotoğrafı"
                        className="w-full h-full object-cover object-center"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
                <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-sage-400 rounded-full filter blur-3xl opacity-30"></div>
                <div className="absolute -top-8 -right-8 w-48 h-48 bg-coffee-400 rounded-full filter blur-3xl opacity-30"></div>
              </div>
          </div>
        </div>
      </section>

      {/* Menu Section  */}
      <section id="menu" className="py-24 bg-gradient-to-b from-coffee-50 to-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgb(157, 124, 87) 35px, rgb(157, 124, 87) 37px)`,
        }}></div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center mb-12">
            <span className="text-sage-700 font-semibold tracking-wider text-sm uppercase mb-4 block">
              Lezzetler
            </span>
            <h2 className="text-5xl md:text-6xl font-serif font-bold text-coffee-900 mb-6">
              Menümüz
            </h2>
            <p className="text-coffee-600 text-lg max-w-2xl mx-auto mb-8">
              Özenle hazırlanan kahvelerimiz ve taze lezzetlerimiz
            </p>
            
            {/* Kategori Filtre Butonları - Desktop */}
            <div className="hidden md:flex flex-wrap gap-3 justify-center mb-8">
              {menuCategories.slice(0, 4).map((category, index) => (
                <button
                  key={index}
                  onClick={() => {
                    const element = document.getElementById(`category-${index}`);
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="px-4 py-2 rounded-full bg-white border-2 border-coffee-200 text-coffee-700 hover:border-sage-400 hover:bg-sage-50 transition-all duration-300 flex items-center gap-2"
                >
                  <span>{category.icon}</span>
                  <span>{category.category}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Desktop Menü - Compact Grid */}
          <div className="hidden md:block">
            {displayedCategories.map((category, catIndex) => (
              <div
                id={`category-${catIndex}`}
                key={catIndex}
                className="mb-12 last:mb-0"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="text-2xl">{category.icon}</div>
                  <h3 className="text-3xl font-serif font-bold text-coffee-800">
                    {category.category}
                  </h3>
                </div>
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {category.items.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="bg-white/90 backdrop-blur-sm rounded-2xl p-4 border-2 border-coffee-200/50 hover:border-sage-300 hover:shadow-lg transition-all duration-300 group"
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden border-2 border-coffee-200/50 group-hover:border-sage-300 transition-colors duration-300">
                          <img 
                            src={getImageUrl(item.image)}
                            alt={item.name}
                            className="w-full h-full object-cover"
                            loading="lazy"
                            onError={(e) => {
                              e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23d4c4a8' width='100' height='100'/%3E%3Ctext fill='%239d7c57' font-family='Arial' font-size='40' x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle'%3E☕%3C/text%3E%3C/svg%3E`;
                            }}
                          />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex justify-between items-start mb-1">
                            <h4 className="font-semibold text-base text-coffee-900 group-hover:text-sage-700 transition-colors duration-300">
                              {item.name}
                            </h4>
                            <span className="text-rose-500 font-bold text-base ml-4 flex-shrink-0">
                              {item.price}
                            </span>
                          </div>
                          {item.desc && (
                            <p className="text-coffee-600/80 text-sm leading-relaxed mt-1">
                              {item.desc}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Tümünü Göster/Gizle Butonu */}
            {!showAllCategories && menuCategories.length > 4 && (
              <div className="text-center mt-8">
                <button
                  onClick={() => setShowAllCategories(true)}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-coffee-800 text-white hover:bg-coffee-900 transition-colors duration-300"
                >
                  Tüm Kategorileri Göster ({menuCategories.length - 4} daha)
                  <ChevronDown className="w-4 h-4" />
                </button>
              </div>
            )}

            {showAllCategories && (
              <div className="text-center mt-8">
                <button
                  onClick={() => setShowAllCategories(false)}
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-coffee-200 text-coffee-800 hover:bg-coffee-300 transition-colors duration-300"
                >
                  Daha Az Göster
                  <ChevronUp className="w-4 h-4" />
                </button>
              </div>
            )}
          </div>

          {/* Mobile Menü - Accordion yapısı */}
          <div className="md:hidden space-y-4">
            {menuCategories.map((category, catIndex) => (
              <div
                key={catIndex}
                className="bg-white/90 backdrop-blur-sm rounded-3xl border-2 border-coffee-200/50 overflow-hidden"
              >
                <button
                  onClick={() => toggleCategory(catIndex)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left"
                >
                  <div className="flex items-center gap-3">
                    <span className="text-xl">{category.icon}</span>
                    <h3 className="text-lg font-serif font-bold text-coffee-800">
                      {category.category}
                    </h3>
                  </div>
                  {expandedCategories.includes(catIndex) ? (
                    <ChevronUp className="w-5 h-5 text-rose-500 flex-shrink-0" />
                  ) : (
                    <ChevronDown className="w-5 h-5 text-rose-500 flex-shrink-0" />
                  )}
                </button>
                
                <div className={`overflow-hidden transition-all duration-500 ${
                  expandedCategories.includes(catIndex) 
                    ? 'max-h-[2000px] opacity-100' 
                    : 'max-h-0 opacity-0'
                }`}>
                  <div className="px-4 pb-4 space-y-3">
                    {category.items.map((item, itemIndex) => (
                      <div key={itemIndex} className="pt-3 border-t border-coffee-100 first:border-t-0">
                        <div className="flex items-start gap-3">
                          <div className="flex-shrink-0 w-14 h-14 rounded-lg overflow-hidden border border-coffee-200/50">
                            <img 
                              src={getImageUrl(item.image)}
                              alt={item.name}
                              className="w-full h-full object-cover"
                              loading="lazy"
                              onError={(e) => {
                                e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Crect fill='%23d4c4a8' width='100' height='100'/%3E%3Ctext fill='%239d7c57' font-family='Arial' font-size='40' x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle'%3E☕%3C/text%3E%3C/svg%3E`;
                              }}
                            />
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex justify-between items-start mb-1">
                              <h4 className="font-semibold text-sm text-coffee-900 truncate">
                                {item.name}
                              </h4>
                              <span className="text-rose-500 font-bold text-sm ml-2 flex-shrink-0">
                                {item.price}
                              </span>
                            </div>
                            {item.desc && (
                              <p className="text-coffee-600/80 text-xs leading-relaxed">
                                {item.desc}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-coffee-200/50">
            <p className="text-coffee-600 italic text-sm">
              *Fiyatlarımıza KDV dahildir. Güncelleme tarihi : 18.01.2026
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="py-24 bg-white">
       <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-sage-700 font-semibold tracking-wider text-sm uppercase mb-4 block">
              Atmosfer
            </span>
            <h2 className="text-5xl font-serif font-bold text-coffee-900 mb-6">
              Galeri
            </h2>
            <p className="text-coffee-600 text-lg max-w-2xl mx-auto">
              Olea'nın sıcak atmosferinden kareler
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((num, i) => (
              <div
                key={i}
                className="relative group overflow-hidden rounded-3xl aspect-square cursor-pointer animate-fadeInUp"
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <img 
                  src={`${process.env.PUBLIC_URL}/images/gallery/foto${num}.jpg`}
                  alt={`Olea Cafe - Fotoğraf ${num}`}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                  onError={(e) => {
                    e.target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect fill='%23d4c4a8' width='400' height='400'/%3E%3Ctext fill='%23ffffff' font-family='serif' font-size='80' x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle'%3EO%3C/text%3E%3C/svg%3E`;
                  }}
                />
                <div className="absolute inset-0 bg-coffee-900/0 group-hover:bg-coffee-900/30 transition-all duration-500 flex items-center justify-center">
                  <div className="transform scale-0 group-hover:scale-100 transition-transform duration-500">
                    <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                      <Heart className="w-6 h-6 text-rose-500" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

     {/* Contact Section */}
      <section id="contact" className="py-24 bg-gradient-to-b from-coffee-50 to-sage-50 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgb(90, 115, 89) 1px, transparent 0)`,
          backgroundSize: '50px 50px'
        }}></div>
        
        <div className="max-w-4xl mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <span className="text-sage-700 font-semibold tracking-wider text-sm uppercase mb-4 block">
              Bize Ulaşın
            </span>
            <h2 className="text-5xl font-serif font-bold text-coffee-900 mb-6">
              İletişim & Rezervasyon
            </h2>
            <p className="text-coffee-600 text-lg">
              Size en iyi hizmeti sunabilmemiz için bize ulaşın
            </p>
          </div>

          {/* İletişim Bilgileri */}
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 border-2 border-sage-200 shadow-xl">
            <div className="space-y-8">
              <div className="text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-rose-100 to-sage-100 flex items-center justify-center mx-auto mb-6">
                  <Phone className="w-10 h-10 text-rose-600" />
                </div>
                <h3 className="text-2xl font-serif font-bold text-coffee-900 mb-4">
                  Bize Nasıl Ulaşabiliriz?
                </h3>
                <p className="text-coffee-600 text-lg leading-relaxed mb-6">
                  Rezervasyon, soru ve görüşleriniz için bize ulaşın
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {/* Telefon & Rezervasyon */}
                <div className="bg-coffee-50/30 rounded-2xl p-6 border border-sage-200 hover:border-sage-300 transition-colors">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-xl bg-rose-100 flex items-center justify-center">
                      <Phone className="w-6 h-6 text-rose-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg text-coffee-900">Telefon & Rezervasyon</h4>
                      <p className="text-sm text-coffee-500">Hızlı rezervasyon için</p>
                    </div>
                  </div>
                  <a 
                    href="tel:+905072434045"
                    className="text-2xl font-bold text-rose-600 hover:text-rose-700 transition-colors inline-block mb-2"
                  >
                    +90 507 243 40 45
                  </a>
                  <p className="text-sm text-coffee-500">
                    Her gün 09:00 - 00:00 arası
                  </p>
                </div>

                {/* E-posta */}
                <div className="bg-coffee-50/30 rounded-2xl p-6 border border-sage-200 hover:border-sage-300 transition-colors">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-xl bg-sage-100 flex items-center justify-center">
                      <Mail className="w-6 h-6 text-sage-700" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg text-coffee-900">E-posta</h4>
                      <p className="text-sm text-coffee-500">Detaylı sorularınız için</p>
                    </div>
                  </div>
                  <a 
                    href="mailto:info@oleauskudar.com"
                    className="text-xl font-medium text-sage-700 hover:text-sage-800 transition-colors inline-block mb-2"
                  >
                    info@oleauskudar.com
                  </a>
                  <p className="text-sm text-coffee-500">
                  </p>
                </div>
              </div>

              {/* Adres */}
              <div className="bg-gradient-to-r from-coffee-50/50 to-sage-50/50 rounded-2xl p-6 border border-sage-200">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center">
                    <MapPin className="w-6 h-6 text-amber-700" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-lg text-coffee-900">Adresimiz</h4>
                    <p className="text-sm text-coffee-500">Bizi ziyaret etmek için</p>
                  </div>
                </div>
                <div className="mb-4">
                  <p className="text-coffee-800 font-medium text-lg">
                    Aziz Mahmut Hüdayi Mah. Uncular Cad. No 19/A
                  </p>
                  <p className="text-coffee-700">Üsküdar, Istanbul, Turkey</p>
                </div>
                <a 
                  href="https://maps.google.com/?q=Aziz+Mahmut+Hüdayi+Mah.+Uncular+Cad.+No+19/A+Üsküdar+Istanbul"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-sage-300 text-sage-700 hover:text-sage-800 hover:border-sage-400 rounded-xl transition-colors font-medium"
                >
                  <MapPin className="w-4 h-4" />
                  <span>Haritada Göster</span>
                </a>
              </div>

              {/* Çalışma Saatleri & Sosyal Medya */}
              <div className="grid md:grid-cols-2 gap-6">
                {/* Çalışma Saatleri */}
                <div className="bg-coffee-50/30 rounded-2xl p-6 border border-sage-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-xl bg-blue-100 flex items-center justify-center">
                      <Clock className="w-6 h-6 text-blue-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg text-coffee-900">Çalışma Saatleri</h4>
                      <p className="text-sm text-coffee-500">Ziyaret saatlerimiz</p>
                    </div>
                  </div>
                  <div className="space-y-2">
                    <div className="flex justify-between items-center py-2 border-b border-coffee-200/50">
                      <span className="text-coffee-700">Pazartesi - Pazar</span>
                      <span className="font-semibold text-coffee-900">09:00 - 00:00</span>
                    </div>
                    <p className="text-sm text-coffee-500 pt-2">
                      Bayram günlerinde açığız
                    </p>
                  </div>
                </div>

                {/* Sosyal Medya */}
                <div className="bg-coffee-50/30 rounded-2xl p-6 border border-sage-200">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-xl bg-rose-100 flex items-center justify-center">
                      <Instagram className="w-6 h-6 text-rose-600" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg text-coffee-900">Sosyal Medya</h4>
                      <p className="text-sm text-coffee-500">Bizi takip edin</p>
                    </div>
                  </div>
                  <a 
                    href="https://www.instagram.com/oleauskudar/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 bg-gradient-to-r from-rose-500 to-rose-600 hover:from-rose-600 hover:to-rose-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 hover:shadow-lg w-full justify-center"
                  >
                    <Instagram className="w-5 h-5" />
                    <span>Instagram'da Takip Edin</span>
                  </a>
                  <p className="text-sm text-coffee-500 mt-3 text-center">
                    @oleauskudar
                  </p>
                </div>
              </div>
              {/* Motivasyon Mesajı */}
              <div className="text-center pt-6 border-t border-sage-200">
                <p className="text-xl font-serif text-coffee-800 italic mb-2">
                  "Sıcak bir karşılama ve lezzetli bir deneyim için buradayız"
                </p>
                <p className="text-coffee-600">
                  Görüşmek üzere! ☕
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-coffee-900 text-coffee-100 py-12 border-t-4 border-rose-400">
       <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-3">
              <span className="text-2xl font-serif font-bold text-white">Olea</span>
            </div>
            <p className="text-sm text-center md:text-left text-coffee-200">
              © 2026 Olea Üsküdar. Tüm hakları saklıdır.
            </p>
            <div className="flex gap-6 text-sm text-coffee-200">          
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
